import React from 'react';
import { Box, HStack, Link, Text } from '@chakra-ui/react';
import { theme as mythboundTheme } from '../../config/theme';
import { useLocation } from 'react-router';

interface GlobalFooterProps {
  hideOnRoutes?: string[];
}

/**
 * Global footer that exposes Terms/Privacy links on both public and authenticated pages.
 * Hidden on immersive routes when configured via hideOnRoutes.
 */
export const GlobalFooter: React.FC<GlobalFooterProps> = ({ hideOnRoutes = [] }) => {
  const location = useLocation();
  const shouldHide = hideOnRoutes.some((path) => location.pathname.startsWith(path));
  if (shouldHide) return null;

  return (
    <Box
      as="footer"
      mt={8}
      borderTop="1px solid rgba(255,255,255,0.08)"
      pt={4}
      pb={6}
      color={mythboundTheme.colors.secondary.white}
      fontFamily={mythboundTheme.typography.fontFamily.body}
    >
      <HStack spacing={6} justify="center" wrap="wrap">
        <Link href="/terms" color={mythboundTheme.colors.primary.main} textDecoration="underline">
          Terms of Service
        </Link>
        <Link href="/privacy" color={mythboundTheme.colors.primary.main} textDecoration="underline">
          Privacy Policy
        </Link>
      </HStack>
      <Text textAlign="center" mt={3} fontSize="sm" opacity={0.7}>
        Mythbound™ — Respectful play and privacy-first experience.
      </Text>
    </Box>
  );
};

export default GlobalFooter;
